/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import React from "react";
import Button from "../../../component/button";
import Grid from "@mui/material/Grid";

import Delete from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";

//table imports
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import Typography from "@mui/material/Typography";

import Input from "../../../component/inputpm";
import classes from "../createPackage/createPackage.module.css";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import currencyFormatter from "../../../helper/currencyFormatter";
import { TableContainer } from "@mui/material";

const Variations = (props) => {
  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid
          item
          size={{
            xs: 12,
          }}
        ></Grid>
        <Grid
          item
          size={{
            xs: 1,
          }}
        ></Grid>
        <Grid
          item
          size={{
            xs: 10,
          }}
        >
          <Typography variant="h6" id="variantTable" style={{ width: "100%" }}>
            Define Variants / Combination for : {props.name ? props.name : ""}
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell align="center">
                    {props.t("PRODUCT_CODE")}
                  </TableCell>
                  <TableCell align="center">{props.t("PRICE")} ($)</TableCell>
                  <TableCell align="center">
                    {props.t("SETTLEMENT_CODE")}
                  </TableCell>
                  <TableCell align="center">{props.t("ACTION")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.variants && props.variants.length > 0 ? (
                  props.variants.map((row, index) => (
                    <TableRow key={index} style={{ cursor: "pointer" }}>
                      <TableCell>
                        <Input
                          name={"variantName"}
                          value={
                            row.variantName
                              ? row.variantName
                              : props.variantName
                          }
                          divClass={classes.customDiv}
                          onChange={(event) => props.onChange(event)}
                          placeholder={props.t("NAME") + " *"}
                          size={"small"}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Input
                          divClass={classes.customDiv}
                          name={"variantFeatureCode"}
                          value={
                            row.variantFeatureCode
                              ? row.variantFeatureCode
                              : props.variantFeatureCode
                          }
                          onChange={(event) => props.onChange(event)}
                          placeholder={"Product Code *"}
                          size={"small"}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Input
                          divClass={classes.customDiv}
                          name={"variantPrice"}
                          value={
                            row.variantPrice
                              ? row.variantPrice
                              : props.variantPrice
                          }
                          onChange={(event) => props.onChange(event)}
                          onKeyDown={(event) => {
                            // Intercept the letter "e" (Key code 69) and prevent its default behavior
                            if (event.keyCode === 69) {
                              event.preventDefault();
                            }
                            if (event.key === ",") {
                              event.preventDefault();
                            }
                          }}
                          placeholder={
                            props.t("PRICE") +
                            " * : (" +
                            currencyFormatter("", false) +
                            ")"
                          }
                          type={"number"}
                          size={"small"}
                          min={1}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Input
                          divClass={classes.customDiv}
                          name={"variantSettlementContentId"}
                          value={
                            row.variantSettlementContentId
                              ? row.variantSettlementContentId
                              : props.variantSettlementContentId
                          }
                          onChange={(event) => props.onChange(event)}
                          placeholder={props.t("SETTLEMENT_CODE")}
                          size={"small"}
                        />
                      </TableCell>

                      <TableCell align="center">
                        {row.variantName ? (
                          <Tooltip title="Remove Variant">
                            <Delete
                              onClick={(event) =>
                                props.performVariantAction(
                                  row,
                                  index,
                                  "removeVariant",
                                )
                              }
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title="Add Variant">
                            <AddBoxRoundedIcon
                              onClick={(event) =>
                                props.performVariantAction(
                                  row,
                                  index,
                                  "addVariant",
                                )
                              }
                            />
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={5}>
                      <Button
                        onClick={(event) =>
                          props.performVariantAction("", "", "addVariantRow")
                        }
                        color="primary"
                      >
                        {props.t("NO_ITEMS_DEFINED")}. Click to Define.
                      </Button>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid
          item
          size={{
            xs: 1,
          }}
        ></Grid>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(
  withTranslation("translations")(Variations),
);
